import React from "react"
import { Modal } from "../components"
import { primaryButtonStyle, secondaryButtonStyle, inputStyle } from "../styles/commonStyles"
import { COLORS, SPACING, TYPOGRAPHY } from "../constants/theme"

const SubscriptionModal = ({ isOpen, onClose, customer, planList, form, onSubscribe }) => {
	const selectedPlan = planList.find((plan) => plan.id === form.values.planId)

	const footer = (
		<>
			<button
				onClick={onClose}
				disabled={form.loading}
				style={{
					...secondaryButtonStyle,
					opacity: form.loading ? 0.6 : 1,
					cursor: form.loading ? "not-allowed" : "pointer",
				}}
			>
				ยกเลิก
			</button>
			<button
				onClick={onSubscribe}
				disabled={!form.values.planId || form.loading}
				style={{
					...primaryButtonStyle,
					opacity: !form.values.planId || form.loading ? 0.6 : 1,
					cursor: !form.values.planId || form.loading ? "not-allowed" : "pointer",
				}}
			>
				{form.loading ? "กำลังเพิ่ม..." : "เพิ่มแพ็คเกจ"}
			</button>
		</>
	)

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={`เพิ่มแพ็คเกจสำหรับลูกค้า: ${customer?.id}`} footer={footer} size="md">
			<div style={{ marginBottom: SPACING.md }}>
				<label
					style={{
						display: "block",
						marginBottom: SPACING.sm,
						fontWeight: TYPOGRAPHY.fontWeight.medium,
						color: COLORS.gray700,
					}}
				>
					เลือกแพ็คเกจ:
				</label>
				<select
					value={form.values.planId}
					onChange={(e) => form.setValue("planId", e.target.value)}
					style={{
						...inputStyle,
						width: "100%",
						cursor: "pointer",
					}}
				>
					<option value="">-- เลือกแพ็คเกจ --</option>
					{planList.map((plan) => (
						<option key={plan.id} value={plan.id}>
							{plan.name} - {plan.price?.toLocaleString()} ฿ ({plan.type})
						</option>
					))}
				</select>
			</div>

			{selectedPlan && (
				<div
					style={{
						marginBottom: SPACING.md,
						padding: SPACING.sm,
						backgroundColor: COLORS.gray50,
						borderRadius: "4px",
						border: `1px solid ${COLORS.border}`,
					}}
				>
					<div
						style={{
							fontWeight: TYPOGRAPHY.fontWeight.semibold,
							marginBottom: SPACING.xs,
							color: COLORS.gray800,
						}}
					>
						รายละเอียดแพ็คเกจ:
					</div>
					<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: COLORS.gray700 }}>
						<div>
							<strong>แพ็คเกจ:</strong> {selectedPlan.name}
						</div>
						<div>
							<strong>ราคา:</strong> {selectedPlan.price?.toLocaleString()} ฿
						</div>
						<div>
							<strong>ประเภท:</strong> {selectedPlan.type}
						</div>
						{selectedPlan.description && (
							<div>
								<strong>รายละเอียด:</strong> {selectedPlan.description}
							</div>
						)}
					</div>
				</div>
			)}
		</Modal>
	)
}

export default SubscriptionModal
